import { Box, Flex, Text } from "@chakra-ui/react";
import { faUser } from "@fortawesome/pro-light-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button, Modal } from "@morressier/alembic";

type ProxyUserModalProps = {
  onClose: () => void;
  isOpen: boolean;
  modalTitle: string,
  modalSubtitle: string;
  modalDescription: string;
  buttonText: string;
  handleProceed: () => void;
  user: {
    firstName: string;
    lastName: string;
  }
  isLoading?: boolean;
}
const ProxyUserModal = ({ onClose, isOpen, modalTitle, modalSubtitle, modalDescription, buttonText, handleProceed, user, isLoading = false }: ProxyUserModalProps) => {
  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      width="500px"
      closeButtonProps={{
        hidden: true
      }}
    >
      <Flex padding={5} direction={'column'} gap={3}>
        <Box>
          <FontAwesomeIcon icon={faUser} size="2x" />
        </Box>
        <Flex direction={'column'} gap={3}>
          <Text textStyle={'headingGroup'}>{modalTitle}</Text>
          <Text
            textStyle={'textBody'}
            whiteSpace="normal"
            overflowWrap="anywhere"
          >
            {modalSubtitle}{' '}
            <Box as="span" textStyle={'headingLine'}>
              {user?.firstName} {user?.lastName}
            </Box>
          </Text>
          <Text textStyle={'textBody'}>{modalDescription}</Text>
        </Flex>

        <Flex
          justifyContent="flex-end"
          gap={2}
          alignItems="center"
          marginTop={4}
          width="100%"
        >
          <Button onClick={onClose} variant="secondary">
            Cancel
          </Button>
          <Button
            variant="primary"
            type="submit"
            onClick={handleProceed}
            disabled={isLoading}
          >
            {buttonText}
          </Button>
        </Flex>
      </Flex>
    </Modal>
  )
}

export default ProxyUserModal;
